import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

interface TotalTicketsCardProps {
  value: number;
}

const TotalTicketsCard: React.FC<TotalTicketsCardProps> = ({ value }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1, minWidth: { xs: '100%', sm: 'calc(50% - 8px)', lg: 'auto' } }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="body2" sx={{ color: '#64748b', mb: 1 }}>
              Total Tickets
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 600, color: '#1e293b' }}>
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: '#3b82f615',
              borderRadius: '50%',
              p: 1,
              display: 'flex',
            }}
          >
            <AssessmentIcon sx={{ color: '#3b82f6' }} />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TotalTicketsCard;
